import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';
import WhatsAppDiagnostic from '../home/components/WhatsAppDiagnostic';

export default function CommentCaMarche() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <div className="pt-24 pb-16 px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Comment ça marche ?</h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Découvrez comment notre plateforme vous met en relation avec des artisans qualifiés pour vos travaux de fenêtres
            </p>
          </div>

          <div className="bg-teal-50 border-l-4 border-teal-600 p-6 rounded-lg mb-16">
            <div className="flex items-start gap-4">
              <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="ri-information-line text-2xl text-white"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Notre rôle : Plateforme de mise en relation</h3>
                <p className="text-gray-700">
                  <strong>fenetreslyon.fr</strong> est une plateforme de mise en relation. Nous ne réalisons pas les travaux nous-mêmes. 
                  Notre mission est de vous connecter avec des artisans partenaires qualifiés et de confiance dans votre région.
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-20">
            <div className="text-center">
              <div className="w-20 h-20 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-3xl font-bold text-white">1</span>
              </div>
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-list-3-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Décrivez votre projet</h3>
              <p className="text-gray-600">
                Remplissez notre formulaire en quelques minutes : type de fenêtre, problème rencontré, vos coordonnées.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-3xl font-bold text-white">2</span>
              </div>
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-search-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Nous trouvons l'artisan</h3>
              <p className="text-gray-600">
                Nous sélectionnons un ou plusieurs artisans qualifiés de votre secteur et leur transmettons votre demande.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-3xl font-bold text-white">3</span>
              </div>
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-phone-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">L'artisan vous contacte</h3>
              <p className="text-gray-600">
                L'artisan partenaire vous contacte directement sous 24h pour discuter de votre projet et établir un devis.
              </p>
            </div>

            <div className="text-center">
              <div className="w-20 h-20 bg-teal-600 rounded-full flex items-center justify-center mx-auto mb-6">
                <span className="text-3xl font-bold text-white">4</span>
              </div>
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-tools-line text-3xl text-teal-600"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Travaux réalisés</h3>
              <p className="text-gray-600">
                Si le devis vous convient, l'artisan réalise les travaux selon les conditions convenues ensemble.
              </p>
            </div>
          </div>

          <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12 mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Nos engagements</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-shield-check-line text-2xl text-green-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Artisans vérifiés</h3>
                  <p className="text-gray-600">
                    Tous nos artisans partenaires sont vérifiés : immatriculation, assurances professionnelles, qualifications.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-money-euro-circle-line text-2xl text-green-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Service gratuit</h3>
                  <p className="text-gray-600">
                    La mise en relation est 100% gratuite. Vous ne payez que les travaux effectués par l'artisan.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-2xl text-green-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Réponse rapide</h3>
                  <p className="text-gray-600">
                    Un artisan vous contacte sous 24h maximum (souvent bien plus rapidement).
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-close-circle-line text-2xl text-green-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Sans engagement</h3>
                  <p className="text-gray-600">
                    Vous êtes libre d'accepter ou de refuser le devis. Aucune obligation d'achat.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-green-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Artisans locaux</h3>
                  <p className="text-gray-600">
                    Nous travaillons uniquement avec des artisans de votre région (Lyon et agglomération).
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-lock-line text-2xl text-green-600"></i>
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">Données protégées</h3>
                  <p className="text-gray-600">
                    Vos données sont protégées et utilisées uniquement pour la mise en relation (RGPD).
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-2xl p-8 md:p-12 mb-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center">Questions fréquentes</h2>
            <div className="space-y-6">
              <div className="bg-white rounded-lg p-6 shadow-sm">
                <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-3">
                  <i className="ri-question-line text-teal-600"></i>
                  Est-ce vraiment gratuit ?
                </h3>
                <p className="text-gray-700 pl-9">
                  Oui, la mise en relation via notre plateforme est 100% gratuite. Vous ne payez que les travaux effectués par l'artisan que vous choisissez, selon le devis accepté.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-sm">
                <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-3">
                  <i className="ri-question-line text-teal-600"></i>
                  Qui réalise les travaux ?
                </h3>
                <p className="text-gray-700 pl-9">
                  Les travaux sont réalisés par des artisans partenaires indépendants, qualifiés et assurés. Nous ne réalisons pas les travaux nous-mêmes, nous facilitons uniquement la mise en contact.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-sm">
                <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-3">
                  <i className="ri-question-line text-teal-600"></i>
                  Suis-je obligé d'accepter le devis ?
                </h3>
                <p className="text-gray-700 pl-9">
                  Non, absolument pas. La demande de devis ne vous engage à rien. Vous êtes totalement libre d'accepter ou de refuser le devis proposé par l'artisan.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-sm">
                <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-3">
                  <i className="ri-question-line text-teal-600"></i>
                  Combien d'artisans vont me contacter ?
                </h3>
                <p className="text-gray-700 pl-9">
                  En général, un seul artisan qualifié de votre secteur vous contactera. Dans certains cas, nous pouvons transmettre votre demande à plusieurs artisans pour vous offrir plus de choix.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-sm">
                <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-3">
                  <i className="ri-question-line text-teal-600"></i>
                  Que se passe-t-il avec mes données personnelles ?
                </h3>
                <p className="text-gray-700 pl-9">
                  Vos coordonnées sont transmises uniquement aux artisans partenaires dans le cadre de votre demande. Elles sont protégées conformément au RGPD. Consultez notre <a href="/politique-confidentialite" className="text-teal-600 hover:text-teal-700 font-medium">Politique de Confidentialité</a> pour plus d'informations.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-sm">
                <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-3">
                  <i className="ri-question-line text-teal-600"></i>
                  Puis-je annuler ma demande ?
                </h3>
                <p className="text-gray-700 pl-9">
                  Oui, vous pouvez nous contacter à tout moment pour annuler votre demande. Si un artisan vous a déjà contacté, nous vous recommandons de l'en informer directement par courtoisie.
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-sm">
                <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-3">
                  <i className="ri-question-line text-teal-600"></i>
                  Que faire en cas de problème avec l'artisan ?
                </h3>
                <p className="text-gray-700 pl-9">
                  En cas de litige avec un artisan partenaire, contactez d'abord directement l'artisan pour trouver une solution amiable. Si le problème persiste, vous pouvez faire appel au médiateur de la consommation (coordonnées dans nos <a href="/mentions-legales" className="text-teal-600 hover:text-teal-700 font-medium">Mentions Légales</a>).
                </p>
              </div>

              <div className="bg-white rounded-lg p-6 shadow-sm">
                <h3 className="text-lg font-bold text-gray-900 mb-3 flex items-center gap-3">
                  <i className="ri-question-line text-teal-600"></i>
                  Les artisans sont-ils assurés ?
                </h3>
                <p className="text-gray-700 pl-9">
                  Oui, tous nos artisans partenaires disposent obligatoirement d'une assurance responsabilité civile professionnelle et d'une assurance décennale en cours de validité.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-teal-600 to-teal-700 rounded-2xl p-8 md:p-12 text-center text-white">
            <h2 className="text-3xl font-bold mb-4">Prêt à démarrer votre projet ?</h2>
            <p className="text-xl text-teal-50 mb-8 max-w-2xl mx-auto">
              Décrivez votre besoin en 2 minutes et recevez un devis personnalisé sous 24h
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="/#contact"
                className="bg-white text-teal-600 px-8 py-4 rounded-lg font-semibold text-lg hover:bg-gray-50 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                <i className="ri-send-plane-fill mr-2"></i>
                Demander un devis gratuit
              </a>
              <a
                href="tel:0980803684"
                className="bg-teal-800 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-teal-900 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                09 80 80 36 84
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* WhatsApp Diagnostic */}
      <WhatsAppDiagnostic />

      <Footer />
    </div>
  );
}
